jQuery(document).ready(function($) {

  let isReviewsPg = $('body#reviews').length;
  
  if ( $('body').hasClass('template-index') || $('body').hasClass('template-product') || isReviewsPg ) {
    let runCount = 0;
    const maxRuns = 10;
  
    const intervalId = setInterval(function () {
      runCount++;
  
      const $fwEmbed = $('fw-embed-feed')[0];
      if ($fwEmbed && $fwEmbed.shadowRoot) {
        const branding = $fwEmbed.shadowRoot.querySelector('a[aria-label*="Powered by Firework"]');
        if (branding) {
          branding.style.display = 'none';
        }
      }
  
      if (runCount >= maxRuns) {
        clearInterval(intervalId);
      }
    }, 1000);
  }

  let setVariantImageBackground = () => {
    let isETT = $('body').hasClass('product-id-9708866470209');
    const urlParams = new URLSearchParams(window.location.search);
    const initialVariantID = urlParams.get("variant");
  
    let bgColor;
  
    if(initialVariantID == "49799448166721") {
      bgColor = "#A4B0C3";
    } else if(initialVariantID == "49799448199489") {
      bgColor = "#94A48C";
    }

    if(!isETT) {
      return;
    }
    
    if (!initialVariantID) { 
       $('.product__slide.media--active .image-wrapper').attr('style',`background:#A4B0C3`);
    } else {
      $('.product__slide.media--active .image-wrapper').attr('style',`background:${bgColor}`);
    }
  
    

    $('input[name="options[Color]-template--24274847301953__mainproduct-9708866470209-"]').change(function() {
      let value = $(this).val();
      if(value == "Emerald Green Jar") {
        $('.product__slide.media--active .image-wrapper').attr('style',`background:#94A48C`);
      } else if(value == "Steel Blue Jar") {
        $('.product__slide.media--active .image-wrapper').attr('style',`background:#A4B0C3`);
      }
    })
  }

  setVariantImageBackground();

  // Product Pg Reviews Restructure
  function restructureJudgeMeReviewBlocks() {
    $('.jdgm-rev').each(function () {
      var $review = $(this);
      var $pics = $review.find('.jdgm-rev__pics');
      var $rating = $review.find('.jdgm-row-rating');
      var $author = $review.find('.jdgm-rev__author');
      var $content = $review.find('.jdgm-rev__content');
      var $body = $review.find('.jdgm-rev__body');
      var $title = $review.find('.jdgm-rev__title');
  
      // Move rating above title (for all)
      if ($rating.length && $title.length) {
        $title.before($rating);
      }
  
      // Append author at the end of the review text (for all)
      if ($author.length && $body.length && $body.find('.jdgm-rev__author-inline').length === 0) {
        var authorName = $.trim($author.text());
        if (authorName) {
          var $name = $('<div class="jdgm-rev__author-inline">').text('– ' + authorName);
          $body.append($name);
        }
      }

      var currentTop = parseFloat($review.css('top'));

      if (!isNaN(currentTop) && currentTop !== 0) {
        $review.css('top', (currentTop + 40) + 'px');
      }
    });
  }
  
  let restructureProductReviews = () => {
    let isProductPg = $('body').hasClass('template-product');
  
    if (isProductPg) {
      console.log("HELLO!");
  
      // Initial load
      setTimeout(() => {
        restructureJudgeMeReviewBlocks();
      }, 1500);
  
      // On pagination click
      $(document).on('click', '.jdgm-paginate__page', function () {
        setTimeout(function () {
          restructureJudgeMeReviewBlocks();
        }, 800);
      });
    }
  };
  
  restructureProductReviews();

  let isCollectionPg = $('body').hasClass('template-collection');
  $('.custom-atc-trigger').on('click', function () {
    var $productItem = $(this).closest('.product-item');
    var $realButton = $productItem.find('.quick-add__button');

    if ($realButton.length) {
      $realButton.trigger('click');
    }
  });

});


if (window.innerWidth < 769) {
  new Swiper('#jci-mobile-slider', {
    slidesPerView: 1,
    spaceBetween: 24,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  $('.template-product #cart-bar').addClass("is-visible");
}


const upsellCarousel = document.querySelector('.upsell-carousel.swiper-container');
if (upsellCarousel) {
  new Swiper(upsellCarousel, {
    slidesPerView: 1.1,
    spaceBetween: 16,
    grabCursor: true,
    loop: false,
    freeMode: false,
    pagination: false,
    navigation: false,
  });
}

let jciBadges = $('.jdgm-verified-badge');
jciBadges.appendTo('.footer__block--newsletter');









